// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"4f1eca47","154":"00c0bdf5","189":"1678280c","201":"e5a06c12","337":"c71e0cb2","453":"96640018","541":"e89aaa20","592":"2865d5f9","608":"447ebc78","697":"92e946ae","913":"6150381c","923":"10b12c34","932":"77dc71df","975":"fd22d6f3"}[chunkId] + ".chunk.js";
};